import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { OperatorsVM } from './operators.viewmodel';

const OperatorsContext = React.createContext<OperatorsVM>(null);
const connectOperatorVM = makeConnect(OperatorsContext);

export { OperatorsContext, connectOperatorVM };